import { render } from "./EventAreaChart.vue?vue&type=template&id=4a894f52"
import script from "./EventAreaChart.vue?vue&type=script&lang=js"
export * from "./EventAreaChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__